import React from 'react';

export type BoolNumber = 0 | 1;
export const TRUE: BoolNumber = 1;
export const FALSE: BoolNumber = 0;

export function formatMatchBets(
    matchBets: BoolNumber[] | null,
    matchIndex: number,
    matchResult: BoolNumber[] | null = null,
    isResultOnly: boolean = false
) {
    if (!matchBets) return null;

    const mappedValues = mapMatchBets(matchBets, matchIndex)
        .map((s, index) =>
            s !== '' ? (
                <span
                    key={`result-${matchIndex}-${index + 1}`}
                    className={isResultOnly ? 'match-result' : getClassForBet(matchBets, matchResult, index)}
                >
                    {s}
                </span>
            ) : null
        )
        .filter((s) => s !== null);

    const outputArray: React.JSX.Element[] = [];

    for (let i = 0; i < mappedValues.length; i++) {
        outputArray.push(mappedValues[i]);
        if (i < mappedValues.length - 1) {
            outputArray.push(<span key={`separator-${matchIndex}-${i + 1}`}>{matchIndex >= 14 ? '-' : ','}</span>);
        }
    }

    return outputArray;
}

function getClassForBet(bets: BoolNumber[], result: BoolNumber[] | null, betIndex: number) {
    if (!result) {
        return null;
    }
    if (bets[betIndex] === TRUE && result[betIndex] === TRUE) {
        return 'hit-result';
    }
    return 'missed-result';
}

export function mapMatchBets(bets: BoolNumber[], matchIndex: number) {
    if (matchIndex >= 14) {
        return bets.map((bet: BoolNumber, betIndex: number) => {
            if (bet !== TRUE) {
                return '';
            }
            const result = betIndex % 4;
            return result > 2 ? 'M' : result.toString();
        });
    }
    return bets.map((bet: BoolNumber, betIndex: number) => {
        if (bet !== TRUE) {
            return '';
        }
        return ['1', 'X', '2'][betIndex] ?? '';
    });
}

export function someBetIsHit(matchBets: BoolNumber[], matchResult: BoolNumber[]) {
    return matchBets.some((bet, index) => bet === TRUE && matchResult[index] === TRUE);
}

export function formatBet(bet: BoolNumber, matchIndex: number) {
    return Object.values(bet).join(matchIndex >= 14 ? '-' : ',');
}
